/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// $(function(){
// 	$('.accordionButton').click(function(){
// 		if ($(this).attr('aria-expanded') == 'false') {
// 			$(this).attr('aria-expanded', true);
// 			$(this).next().slideDown();
// 		} else {
// 				$(this).attr('aria-expanded', false);
// 				$(this).next().slideUp();
// 		}
// 	});
// });





document.addEventListener('DOMContentLoaded', function() {
	// アコーディオンボタンに対するクリックイベントリスナーを設定
	document.querySelectorAll('.accordionButton').forEach(function(button) {
			button.addEventListener('click', function() {
					// aria-expanded属性をチェック
					if (this.getAttribute('aria-expanded') == 'false') {
							this.setAttribute('aria-expanded', 'true');
							this.nextElementSibling.style.display = 'grid'; // 次の要素を表示
							this.nextElementSibling.style.height = 'auto';
					} else {
							this.setAttribute('aria-expanded', 'false');
							this.nextElementSibling.style.display = 'none'; // 次の要素を非表示
							this.nextElementSibling.style.height = '0';
					}
			});
	});
});

// 最初にselect要素を非表示にするスタイルを追加
const style = document.createElement('style');
style.textContent = 'select.input-full { opacity: 0; transition: opacity 0.2s; }';
document.head.appendChild(style);

// ページ読み込み後に実行
window.addEventListener('load', function() {
    // 少し待ってから実行（動的コンテンツ対応）
    setTimeout(function() {
        // すべてのselect要素を取得
        const selects = document.querySelectorAll('select.input-full');
        
        selects.forEach(function(select) {
            // 各selectの最初のoption（プレースホルダー）を取得
            const firstOption = select.querySelector('option[value=""]');
            
            if (firstOption) {
                const text = firstOption.textContent.trim();
                
                // テキストを日本語に置換
                if (text === 'Year') {
                    firstOption.textContent = '年';
                } else if (text === 'Month') {
                    firstOption.textContent = '月';
                } else if (text === 'Day') {
                    firstOption.textContent = '日';
                }
            }
            
            // 置換後に表示
            select.style.opacity = '1';
        });
    }, 100); // 100ミリ秒待機
});
